const toggleFilter = (event) => {
  const prev = document.getElementsByClassName('pill--active');
  for(let i = 0; i < prev.length; i++) {
    prev[i].classList.remove('pill--active');
  }
  event.target.classList.add('pill--active');

  const filters = document.querySelector(`[data-category="${event.currentTarget.dataset.category}"]`).getAttribute('data-category');

  const clients = document.querySelectorAll('[data-clientfilters]');

  clients.forEach(client => {
    const clientfilters = client.getAttribute('data-clientfilters');
    if (!clientfilters.includes(filters)) {
      client.classList.add('filtered');
    } else {
      client.classList.remove('filtered');
    }

    if(filters === undefined) {
      if(client.classList.contains('filtered')) {
        client.classList.remove('filtered');
      }
    }
  });

  const projects = document.querySelectorAll('[data-projectfilters]');

  projects.forEach(project => {
    const projectfilters = project.getAttribute('data-projectfilters');

    if(!projectfilters.includes(filters)) {
      project.classList.add('filtered');
    } else {
      project.classList.remove('filtered');
    }
  });
};

const filterButtons = document.getElementsByClassName('func-filter__pill');

for(let i = 0; i < filterButtons.length; i++) {
  filterButtons[i].addEventListener('click', toggleFilter);
}
